export default {
  transactionCodeResults(currentState, value) {
    const state = currentState;
    state.transactionCodeResults = Object.assign([], value);
  },
};
